import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyA92z6koHw9v3vFDRcxY4YBMWREVfFqcEg",
  authDomain: "almuwasholah-2e2c0.firebaseapp.com",
  projectId: "almuwasholah-2e2c0",
  storageBucket: "almuwasholah-2e2c0.firebasestorage.app",
  messagingSenderId: "639766546048",
  appId: "1:639766546048:web:20ea8d96901934d2afc865",
  measurementId: "G-3K9B3F5N6L"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = typeof window !== 'undefined' ? getAnalytics(app) : null;

export { app, analytics };
